.page { min-height: 100vh; }
.top { display: flex; align-items: center; padding: 24px var(--page-x); border-bottom: var(--border-hair); }
.body { display: flex; flex-direction: column; gap: 32px; max-width: 760px; padding: 40px var(--page-x) 64px; }
.section { display: flex; flex-direction: column; gap: 12px; }
.heading { margin: 0; font-family: var(--font-mono); font-size: 11px; font-weight: 500; letter-spacing: 1.6px; color: var(--hot); text-transform: uppercase; }
.para, .list { margin: 0; font-size: 15px; line-height: 1.6; }
.list { display: flex; flex-direction: column; gap: 6px; padding-left: 20px; }
.inline { text-decoration: underline; }
.footer { padding-top: 16px; border-top: var(--border-hair); }

@media (max-width: 639px) {
  .top { padding: 12px var(--page-x); }
  .body { gap: 28px; padding: 24px var(--page-x) 40px; }
  .para, .list { font-size: 14px; }
}
